module.exports = __webpack_public_path__ + "static/media/bsaHand.b57ebd63.jpeg";